import React, { useState } from "react";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import HeaderBreadCrumbs from "../../Component/BasicComponents/HeaderBreadCrumbs";
import { useGetFTPImportLogs } from "./hooks/useFTP";
import RoundedDropdown from "../../Component/BasicComponents/Dropdowns/RoundedDropdown";

type Props = {};

const FTPLogs = (props: Props) => {
  
  const [filterState,setFilterState] = useState<any>({
    page: 2,
    limit:10,
    search: "",
    sortOrder: "ASC",
    sortColumn: "",
  }) 


  // API
  const {data,isSuccess,isLoading} = useGetFTPImportLogs({enable:true,
    params:{
    page: filterState.page,
    limit:filterState.limit,
    search: filterState.search,
    sortOrder: "ASC",
    sortColumn: "",
  }})
    
  // console.log('TotalRecords',data?.data);

  const FTPImport = !isLoading && isSuccess && data?.data?.ftpImportLogs.map((item:any,index:number)=>({
   
    sr:index + 1,
    date: item?.CreatedAt || '',
    file: item?.FilePath || '',
    totalrecords: item?.NoTotalRecords || 0,
    successfulrecords: item?.NoSuccessfulRecords || 0,
    failedrecords: item?.NoFailedRecords || 0,
    starttime: item?.StartTime || '',
    endtime: item?.EndTime || '',
    processingtime:item?.ProcessingTime || ''
  }))  || []

  const handlePagination =(page:number)=>{
    setFilterState((prev:any)=>({
      ...prev,
      page:page
    }))
  }

  const handleonChangeRowsPerPage =(limit:any,pageNo:any)=>{
     setFilterState((prev:any)=>({
      ...prev,
      page:pageNo,
      limit:limit
     }))
  }

   const handleInputSearch =(e:React.ChangeEvent<HTMLInputElement>)=>{
      setFilterState((prev:any)=>({
          ...prev,
          search:e
      }))
   }

  return (
  <div className="p-2">
      <HeaderBreadCrumbs
        title="FTP File Log"
        buttons={[
          {
            label: "Export",
            onClick: () => alert("Action 2 clicked"),
            color: "#2e8dd3",
          },
        ]}
      />
      <BasicDataTable
        Title="FTP File Logs"
        data={FTPImport||[]}
        columns={FtpExportColumn}
        search={true}
        handleSearch={handleInputSearch}
        DateFilters={true}

        onChangePage={(pageNo:number)=>{
           handlePagination(pageNo);         
        }}
        onChangeRowsPerPage={(newPage:any,page:any)=>{
          handleonChangeRowsPerPage(newPage,page);

        }}
        paginationTotalRows={data?.data?.Pagination?.TotalRecords}
      />
    </div>
  );
};

export default FTPLogs;
const FtpExportColumn = [
  {
    name: "SR",
    selector: (row: { sr: string }) => row.sr,
    sortable: true,
  },
  {
    name: "File",
    selector: (row: { file: string }) => row.file,
    sortable: true,
    wrap:true,
    width:'120px'
  },
  {
    name: "Date",
    selector: (row: { date: string }) => row.date,
    sortable: true,
    width:'120px'
  },
  {
    name: "Total Records",
    selector: (row: { totalrecords: string }) => row.totalrecords,
    width:'150px',
    sortable: true,
  },
  {
    name: "Successful Records",
    selector: (row: { successfulrecords: string }) => row.successfulrecords,
    width:'200px',
    sortable: true,
  },
  {
    name: "Failed Records",
    selector: (row: { failedrecords: string }) => row.failedrecords,
    width:'150px',
    sortable: true,
  },

  {
    name: "Start Time",
    selector: (row: { starttime: string }) => row.starttime ||'-',
    sortable: true,
    wrap:true,
    width:'150px'
  },
  {
    name: "End Time",
    selector: (row: { endtime: string }) => row.endtime ||'-',
    sortable: true,
    wrap:true,
    width:'120px'
  },
  {
    name: "Processing Time",
    selector: (row: { processingtime: string }) => row.processingtime || '-',
    sortable: true,
    width:'180px'
  },
];

